import { useLocation } from "react-router-dom";
import { useContext } from "react";
import { I18nProvider } from "../../i18n";
import { CandidatesRoutes } from "../../Routes/Routes";
import { EmployerContext } from "../../Store/EmployerContext";
import SideMenu from "./Components/SideMenuEmployee/SideMenu";
import "bootstrap";

import MainMenuEmployee from "../../Components/MainMenuEmployee/mainMenu";

import "./Candidate.sass";

const CandidateIndex = () => {
    const user = JSON.parse(localStorage.getItem("user"));
    const pathname = useLocation().pathname;
    const { store, actions } = useContext(EmployerContext);

    const handleMenu = (event) => {
        actions.setOptions(event.currentTarget.dataset.option);
    };

    const handleClear = () => {
        actions.setOptions(0);
    };
    return (
        <I18nProvider locale={store.language}>
            <MainMenuEmployee clearOption={handleClear} />
            <div
                className={
                    pathname === "/candidate/edit-profile"
                        ? "container-fluid candidate-main overflow-hidden"
                        : "container-fluid candidate-main"
                }
            >
                <div
                    className={
                        pathname === "/candidate"
                            ? "row d-flex justify-content-between"
                            : "row"
                    }
                >
                    <div
                        className={
                            pathname === "/candidate"
                                ? "d-none"
                                : pathname === "/candidate/edit-profile"
                                ? "d-none"
                                : pathname ===
                                  "/candidate/internalvacancies"
                                ? "d-none"
                                : "col-md-4 col-lg-4 col-xl-2" //Esta es la clase para el sideMenu
                        }
                    >
                        <SideMenu
                            handleMenu={handleMenu}
                            option={store.options}
                        />
                    </div>
                    <div
                        className={
                            pathname === "/candidate"
                                ? "col-md-12 col-lg-12 col-xl-12"
                                : pathname === "/candidate/edit-profile"
                                ? "col-12"
                                : pathname ===
                                  "/candidate/internalvacancies"
                                ? "col-12"
                                : "px-5 col-md-8 col-lg-8 col-xl-10" //Acá va todo el contenido a la derecha del sideMenu
                        }
                    >
                        <CandidatesRoutes user={user} />
                    </div>
                </div>
            </div>
        </I18nProvider>
    );
};
export default CandidateIndex;
